<template>
  <div>
    <div>
      <span class="xbed-sub-title">企业管理</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">企业管理</BreadcrumbItem>
        <BreadcrumbItem>企业信息</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <section>
      <Card>
        <Row>
          <Col span="6">
            <Form label-position="left">
              <FormItem label="企业名称：" :label-width="150">
                <span>{{basicInfo.name}}</span>
              </FormItem>
              <FormItem label="企业营业执照编码：" :label-width="150">
                <span>{{basicInfo.licenseCode}}</span>
              </FormItem>
              <FormItem label="企业性质：" :label-width="150">
                <span>{{['国有企业','三资企业','集体企业','私营企业'][basicInfo.property]}}</span>
              </FormItem>
              <FormItem label="企业规模：" :label-width="150">
                <span>{{['0-50人','51-100人','101-500人','501-1000人','1000人以上'][basicInfo.scale]}}</span>
              </FormItem>
              <FormItem label="企业地址：" :label-width="150">
                <span>{{`${basicInfo.province} ${basicInfo.city} ${basicInfo.area} ${basicInfo.address}`}}</span>
              </FormItem>
              <FormItem label="企业联系人：" :label-width="150">
                <span>{{basicInfo.juridicalPerson}}</span>
              </FormItem>
              <FormItem label="联系人电话：" :label-width="150">
                <span>{{basicInfo.phone}}</span>
              </FormItem>
              <FormItem label="企业固话：" :label-width="150">
                <span>{{basicInfo.landlineTelephone}}</span>
              </FormItem>
              <FormItem label="负责推广员：" :label-width="150">
                <span>{{basicInfo.extensionClerk}}</span>
              </FormItem>
              <FormItem label="推广员电话：" :label-width="150">
                <span>-</span>
              </FormItem>
              <FormItem label="企业订房折扣：" :label-width="150">
                <span>{{basicInfo.discount}}</span>
              </FormItem>
              <FormItem label="员工标签：" :label-width="150">
                <span>{{staffTagName}}</span>
              </FormItem>
            </Form>
          </Col>
          <Col span="8" style="padding-left:10px">
            <div style="width:100%;min-height:600px;background-color:#eee;">
              <img :src="basicInfo.urlFullPath" width="100%" alt="">
            </div>
          </Col>
          <Col span="10" style="padding-left:10px">
            <Form>
              <FormItem>
                <Input :placeholder="`可通过姓名或手机号查找员工（${staffs.length}位员工）`" icon="ios-search" v-model="searchData" @on-change="searchStaff"></Input>
              </FormItem>
              <FormItem>
                <Table stripe :columns="columns" :data="staffs" size="small" height="450"></Table>
              </FormItem>
              <FormItem>
                <Row v-if="canAdd">
                  <Col span="8">
                    <Input placeholder="输入员工姓名" v-model="staffName" maxlength="30"></Input>
                  </Col>
                  <Col span="12" style="padding-left:20px">
                    <Input placeholder="员工手机号" v-model="staffMobile"></Input>
                  </Col>
                  <Col span="4" style="text-align:center">
                    <Button type="error" @click="addEvent">确认</Button>
                  </Col>
                </Row>
                <Row type="flex" justify="center" class="code-row-bg" style="margin-top:10px">
                  <Col span="4">
                    <Button @click="addStraff">添加</Button>
                  </Col>
                  <Col span="4">
                    <Upload :action="`${path}api/excel/importEnterpriseStaffInfo`" :data="uploadData"
                      :on-success="handleSuccess"
                      :show-upload-list="false"
                      :format="['xls','xlt','xlsx','xlsm']"
                      :on-format-error="handleFormatError"
                      :before-upload="handleBeforeUpload">
                      <Button>批量导入</Button>
                    </Upload>
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </Card>
    </section>
  </div>
</template>

<script>
import API from '../../api';
import Utils from "../../utils";
import Config from "../../config";
import {phoneRegular} from "../../utils/regular"
import Moment from 'moment'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.id = Utils.getUrlParameterByName('id');
    this.path = Config[this.env].analysisUrl;
  },
  mounted() {
    this.$Notice.config({
      top: 200
    });
    this.companyDetail();
  },
  data(){
    return {
      staffTagName: '',
      canAdd: false,
      basicInfo: {},
      staffs: [],
      staffsList: [],
      columns: [
        {
          title: '姓名',
          width: 120,
          align: 'center',
          key: 'name'
        },
        {
          title: '手机号',
          width: 160,
          align: 'center',
          key: 'mobile'
        },
        {
          title: '操作',
          width: 140,
          align: 'center',
          render: (h, param) => {
            return h('Button',{
              props: {
                type: 'error',
                size: 'small'
              },
              on: {
                click: () => {
                  this.delStaff(param.row.id)
                }
              }
            },'删除')
          }
        },
        {
          title: '创建时间',
          width: 250,
          align: 'center',
          render: (h, params) => {
            let createdAt = params.row.createdAt ? Moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss') : '-';
            return h("div", {}, createdAt);
          }
        }
      ],
      searchData: '',
      staffName: '',
      staffMobile: '',
      uploadData: {
        token: '',
        enterpriseId: '',
        createdName: ''
      }
    }
  },
  methods: {
    async getEnterpriseStaffTagFn(staffTagId) {
      let env = Utils.findFromLocalStorage( "env", "dev" )
      let protHeaders = {
        'x-ca-stage': Utils.aliHeaderEnv(env), 
        'Authorization': Utils.findFromLocalStorage("Author-token"),
        // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
      }
      let params = {
        groupId: 2,
        pageNum: 1,
        pageSize: 100,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getEnterpriseStaffTag(params, protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取员工标签列表数据异常',
            desc: resp.msg
          })
          return
        }
        let staffTagName = "无"
        for (let a=0; a<resp.length; a++) {
          if (resp[a].id == staffTagId) {
            staffTagName = resp[a].name
            break
          }
        }
        this.staffTagName = staffTagName
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },
    addStraff() {
      this.canAdd = true;
      this.staffName = '';
      this.staffMobile = ''
    },
    addEvent() {
      if(!Utils.hasPermission('oms_EnterpriseStaff_save')){
        this.$Notice.error({
          title: '无权限操作'
        })
        return
      }
      if(!phoneRegular.test(this.staffMobile)){
        this.$Notice.error({
          title: '手机号码有误'
        })
        return
      }
      if(this.staffName.trim().length==0){
        this.$Notice.error({
          title: '姓名不能为空'
        })
        return
      }
      this.canAdd = false;
      this.addCompanyUserEmployess({
        enterpriseId: this.id,
        mobile: this.staffMobile,
        name: this.staffName,
        createdName: this.username
      });
    },
    searchStaff() {
      if(this.searchData.trim()) {
        this.staffs = this.staffsList.filter((item)=>{
          return (JSON.stringify(item).indexOf(this.searchData)!=-1)
        })
      }else{
        this.staffs = this.staffsList
      }
    },
    async addCompanyUserEmployess(param) {
      let resp = (await API.omsAPI[this.env].enterpriseModule.addCompanyUserEmployess(param,this.token)).data;
      if(resp.retCode){
        if(resp.retCode===61020001){
          this.$Modal.error({
            title: '错误',
            content: `<p>该员工已经与【${resp.data.enterpriseName}】进行了绑定，请先进行解除绑定，或者重新添加员工</p>`
          });
        }else{
          this.$Notice.error({
            title: '添加失败',
            desc: resp.msg
          })
        }
      }else{
        this.$Notice.success({
          title: '添加成功',
        })
        this.companyDetail();
      }
    },
    async companyDetail() {
      let resp = (await API.omsAPI[this.env].enterpriseModule.queryCompanyDetails(this.id, this.token)).data;
      this.basicInfo = resp.repository;
      this.staffs = this.staffsList = resp.enterpriseStaffs;
       this.getEnterpriseStaffTagFn(this.basicInfo.staffTagId)
    },
    async delStaff(id) {
      let resp = (await API.omsAPI[this.env].enterpriseModule.deleteCompanyUserEmployesss(id, this.username, this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '删除失败',
          desc: resp.msg
        })
      }else{
        this.$Notice.success({
          title: '删除成功',
        })
        this.companyDetail()
      }
    },
    handleBeforeUpload() {
      if(!Utils.hasPermission('oms_EnterpriseStaff_save')){
        this.$Notice.error({
          title: '无权限操作'
        })
        return  false
      }
      this.uploadData.token = this.token;
      this.uploadData.enterpriseId = this.id
      this.uploadData.createdName = this.username
      return true;
    },
    handleFormatError() {
      this.$Notice.error({
        title: '文件格式不支持'
      })
      return
    },
    handleSuccess(resp) {
      if(resp.retCode!=21020000){
        this.$Notice.error({
          title: '导入失败',
          desc: resp.msg
        })
      }else{
        this.$Notice.success({
          title: '导入成功'
        })
        this.companyDetail();
      }
    },
  }
}
</script>

  


// WEBPACK FOOTER //
// src/pages/business-management/company-details.vue